import React from 'react';
import styles from './shadowbottom.module.css';

/** Затемнение низа экрана. long — длинное, для мягкого стыка со следующим экраном. */
function ShadowBottom({ long = false }: { long?: boolean }) {
  return (
    <div className={`${styles.shadow} ${long ? styles.long : ''}`}></div>
  );
}

export default ShadowBottom;
